<template>
  <div>
    <div class="a-loading-state a-loading-simil-video"></div>
    <div class="display-flex-row space-between margin-bottom-large margin-top-large width-100-pr">
      <div class="a-loading-state a-loading-simil-button-large"></div>
      <div class="a-loading-state a-loading-simil-button-small"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeSupportModalSkeleton'
}
</script>
